export default "__VITE_ASSET__C7O00uDK__"